module.exports = __webpack_public_path__ + "media/assets/images/SYB-promo-c340ce89a694bb3990a5d03d947694e8.png";